var QuickPanelModule = /** @class */ (function () {
    function QuickPanelModule() {
    }
    return QuickPanelModule;
}());
export { QuickPanelModule };
